import * as config from "../config.js";

export const getLiveEvents = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/liveevents/${clientID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  console.log("!!! RESULTS");
  return results.liveevents;
};

export const getLiveEvent = async (public_id, edit = false) => {
  // We dispatch requestLogin to kickoff the call to the API
  console.log("!!! liveevent ID: ", public_id);
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/liveevent/${public_id}${edit ? "?edit=true" : ""}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const results = await response.json();
  console.log("!!! RESULTS: ", results);

  if (results.success) {
    return results.liveevent;
  }

  return null;
};

export const getCollaboratorLiveEvent = async (public_id, collaborator_id, invitation_token) => {
  // We dispatch requestLogin to kickoff the call to the API
  console.log("!!! liveevent ID: ", public_id);
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/liveevent/${public_id}/${collaborator_id}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify({ invitation_token }),
    }
  );

  const results = await response.json();
  console.log("!!! RESULTS: ", results);

  if (results.success) {
    return results.liveevent;
  }

  return null;
};

export const saveLiveEvent = async (liveevent, client_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  //dispatch(requestLogin(creds));
  //
  liveevent["client"] = { id: client_id, public_id: client_id };
  console.log("!!! LIVE EVENT TO BE SAVED: ", liveevent);
  console.log("!!! KEYS: ", Object.keys(liveevent));
  const fd = new FormData();
  fd.append("video", liveevent.video_file);
  fd.append("video_placeholder_image", liveevent.video_placeholder_image);
  Object.keys(liveevent).forEach((key) => {
    console.log("!!! KEY: ", key);
    if (key !== "video_file" && key !== "video_placeholder_image") {
      console.log("!!! APPENDING TO FORM DATA: ", key, liveevent[key]);
      fd.append(key, typeof liveevent[key] === "object" ? JSON.stringify(liveevent[key]) : liveevent[key]);
    }
  });
  console.log("!!! LIVE EVENT VIDEO FILE: ", liveevent.video_file);
  const method = liveevent.public_id ? "PUT" : "POST";
  const url = liveevent.public_id
    ? `${config.REST_SERVER_URL}/admin/liveevent/${liveevent.public_id}`
    : `${config.REST_SERVER_URL}/admin/liveevent`;
  const response = await fetch(url, {
    method: method,
    crossDomain: true,
    headers: {
    }, credentials: "include",
    body: fd,
  });

  const results = await response.json();
  console.log("!!! RESULTS: ", results);
  if (results.success) {
    return results.liveevent;
  }
  return false;

  /*
  const method = liveevent.public_id ? "PUT" : "POST";
  const url = liveevent.public_id
    ? `${config.REST_SERVER_URL}/admin/liveevent/${liveevent.public_id}`
    : `${config.REST_SERVER_URL}/admin/liveevent`;
  const response = await fetch(url, {
    method: method,
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      },credentials: "include",
    body: JSON.stringify(liveevent),
  });

  const results = await response.json();
  console.log("!!! RESULTS: ", results);
  if (results.success) {
    return results.liveevent;
  }
  return false;
    */
};

export const deleteLiveEvent = async (public_id) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/${public_id}`;
  const response = await fetch(url, {
    method: "DELETE",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const createLiveEvents = async (liveevents) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/bulk_create`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify({ liveevents: liveevents }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const getAgentAnswer = async (public_id, question) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/agent/answer/${public_id}`;
  console.log("!!! AGENT ANSWER URL: ", url);
  console.log("!!! QUESTION: ", question);
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify({ question }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  console.log("!!! RESULTS: ", results);
  return results;
};

export const endLiveEventOnServer = async (token, public_id) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/end/${public_id}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const saveVideoToLiveEvent = async (token, public_id, base64) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/add-video/${public_id}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify({
      video_data: base64,
      video_file_name: `recording-${Date.now()}.webm`,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const inviteCollaborator = async (token, public_id, email) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/invite-collaborator/${public_id}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify({
      email,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
}

export const makeHost = async (token, public_id, collaborator_id) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/make-host/${public_id}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify({
      collaborator_id,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
}

export const removeCollaborator = async (token, public_id, collaborator_id) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/remove-collaborator/${public_id}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify({
      collaborator_id,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
}

export const getCollaboratorInfo = async (live_event_id) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/collaborator-info/${live_event_id}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
}

export const getCollaboratorInfoByInvitationToken = async (live_event_id, collaborator_id, invitation_token) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/collaborator-info-by-invitation-token/${live_event_id}/${collaborator_id}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ invitation_token }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
}

export const getLiveEventInfo = async (public_id) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/info/${public_id}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  if (results.success) {
    return results.liveevent;
  }
  return null;
}

export const startLiveEventRecording = async (event_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/liveevent/start-recording/${event_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const results = await response.json();
  return results;
};

export const stopLiveEventRecording = async (event_id, live_event_recording_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/liveevent/stop-recording/${event_id}/${live_event_recording_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const results = await response.json();
  return results;

};

export const getLiveEventRecordings = async (event_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/liveevent/recordings/${event_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const results = await response.json();
  return results;
};

export const saveLiveEventNickname = async (event_id, nickname) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/save-nickname/${event_id}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify({ nickname }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
}

export const getSaveStatus = async (event_id) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/save-status/${event_id}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
}
